import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ReviewConfirmation.module.scss'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

const DrivingSchoolInformation = ({ t, i18n, setIsError }) => {
  let history = useHistory()

  const [displaySchoolInfo, setDisplaySchoolInfo] = useState(true)

  const drivingSchoolName = useSelector((state) => state.drivingSchool.drivingSchoolInformation.drivingSchoolName)
  const contactName = useSelector((state) => state.drivingSchool.drivingSchoolInformation.contactName)
  const phoneNumber = useSelector((state) => state.drivingSchool.drivingSchoolInformation.phoneNumber)

  useEffect(() => {
    try {
      if (drivingSchoolName === '' || contactName === '' || phoneNumber === '') {
        setDisplaySchoolInfo(false)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const checkNull = (val) => {
    return val === '' ? 'null' : val
  }

  const editDrivingSchoolOnClick = () => {
    history.push(`/${i18n.language}${t('routes.driving_school_info')}`)
  }

  return displaySchoolInfo ? (
    <div className={styles['content_margin']}>
      {/* <div className="row">
        <div className="col-xs-12 col-md-8">
          <h5 className={styles['sub_content']}>
            <strong>{t('review_confirmation.driving_school_info')}</strong>
          </h5>
        </div>
      </div> */}

      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3 style={{ "display": "inline-block" }}>{t('review_confirmation.driving_school_info')}</h3>
          <a href="#" className={[styles['edit_button_right']].join(' ')}
            value={t('review_confirmation.edit')} name={t('review_confirmation.edit')} onClick={editDrivingSchoolOnClick}>
            {t('review_confirmation.edit')}<span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
          </a>
        </div>
      </div>

      <div>
        <div className="row">
          <div className="col-xs-12 col-md-5 col-sm-7 col-lg-5">
            <strong className={styles['margin_bottom']}>{t('review_confirmation.name')}</strong>
          </div>
          {/* <div className={styles['display_none_desktop']}>
            <div className="col-xs-3">
              <button
                className="btn-sm btn-default"
                style={{ margin: '0' }}
                onClick={editDrivingSchoolOnClick}
                value={`driving school info ${t('review_confirmation.edit')}`}
                name={`driving school info ${t('review_confirmation.edit')}`}
              >
                {t('review_confirmation.edit')}
              </button>
            </div>
          </div> */}
          <div className="col-xs-12 col-md-5 col-sm-5 col-lg-7">
            <p className={[styles['margin_bottom'], styles['break_word']].join(' ')}>{checkNull(drivingSchoolName)}</p>
          </div>
          {/* <div className={styles['display_visible_desktop']}>
            <div className="col-md-2 col-sm-2 col-lg-2">
              <button
                className="btn-sm btn-default"
                style={{ margin: '0' }}
                onClick={editDrivingSchoolOnClick}
                value={`driving school info ${t('review_confirmation.edit')}`}
                name={`driving school info ${t('review_confirmation.edit')}`}
              >
                {t('review_confirmation.edit')}
              </button>
            </div>
          </div> */}
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-5 col-sm-7 col-lg-5">
            <strong className={styles['margin_bottom']}>{t('review_confirmation.contact_name')}</strong>
          </div>
          <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
            <p className={[styles['margin_bottom'], styles['break_word']].join(' ')}>{checkNull(contactName)}</p>
          </div>
          <div className="col-xs-12 col-md-5 col-sm-7 col-lg-5">
            <strong className={styles['margin_bottom']}>{t('review_confirmation.driving_school_phone')}</strong>
          </div>
          <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
            <p className={[styles['margin_bottom'], styles['break_word']].join(' ')}>{checkNull(phoneNumber)}</p>
          </div>
        </div>
      </div>
      <hr></hr>
    </div>
  ) : null
}

export default withTranslation('common')(DrivingSchoolInformation)
